import { AlertTriangle } from "lucide-react";

const THREE_DAYS = 3 * 86400000;

export default function ExpiryBanner({ auth }) {
  if (auth.role === "admin" || !auth.codeExpiresAt) return null;
  const ms = new Date(auth.codeExpiresAt) - Date.now();
  if (ms <= 0 || ms >= THREE_DAYS) return null;

  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const when = days >= 1 ? `${days} giorn${days === 1 ? "o" : "i"} e ${hours} ore` : hours >= 1 ? `${hours} ore` : "meno di un'ora";
  const dateStr = new Date(auth.codeExpiresAt).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

  return (
    <div
      data-testid="expiry-warning-banner"
      role="alert"
      className="bg-gradient-to-r from-[#3D2E08] to-[#2A1F05] border-b border-[#E3BC55]/50"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-2.5">
        <AlertTriangle className="w-4 h-4 text-[#FFD700] shrink-0" />
        <p className="text-sm text-amber-100">
          <span className="font-semibold text-[#FFD700]">Il tuo codice scade tra {when}</span>
          <span className="text-amber-200/70"> (il {dateStr}). </span>
          <a
            data-testid="expiry-contact-admin-link"
            href="https://www.zerosignals.it"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#FFD700] underline underline-offset-2 hover:text-white transition-colors"
          >
            Clicca qui per rinnovare.
          </a>
        </p>
      </div>
    </div>
  );
}
